import React from "react";
import { FadeUp } from "../motion/Reveal";

const STEPS = [
    {
        num: "01",
        title: "Descoberta",
        desc: "Mergulhamos no seu negócio. Entrevistas com stakeholders, análise de dados e mapeamento de oportunidades reais.",
        time: "1–2 sem",
    },
    {
        num: "02",
        title: "Estratégia & Design",
        desc: "Arquitetura de informação, wireframes, protótipos de alta fidelidade e sistema de design. Você valida antes de escrever código.",
        time: "2–4 sem",
    },
    {
        num: "03",
        title: "Desenvolvimento",
        desc: "Squad enxuto trabalhando em sprints semanais. Deploy contínuo. Você acompanha tudo pelo nosso board — sem surpresas.",
        time: "4–12 sem",
    },
    {
        num: "04",
        title: "Lançamento & Suporte",
        desc: "Go-live monitorado, treinamento do seu time e suporte contínuo. Não sumimos após o deploy — evoluímos o produto com você.",
        time: "∞",
    },
];

export default function Process() {
    return (
        <section
            id="processo"
            className="relative py-32 md:py-40 border-b border-white/10"
            data-testid="process-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10">
                <div className="grid grid-cols-12 gap-6 mb-20">
                    <FadeUp className="col-span-12 md:col-span-6">
                        <span className="font-mono-tech text-xs tracking-widest text-[#00FF66] uppercase">
                            (Processo) · 04 etapas
                        </span>
                        <h2 className="mt-6 font-display uppercase text-5xl md:text-7xl leading-[0.95] tracking-tighter text-white">
                            Como
                            <br />
                            <span className="text-white/40">funciona.</span>
                        </h2>
                    </FadeUp>
                    <FadeUp
                        className="col-span-12 md:col-span-5 md:col-start-8"
                        delay={0.1}
                    >
                        <p className="text-white/60 text-lg leading-relaxed">
                            Um processo simples, transparente e testado em
                            dezenas de projetos. Você sempre sabe onde estamos
                            e qual o próximo passo.
                        </p>
                    </FadeUp>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-white/10">
                    {STEPS.map((s, i) => (
                        <FadeUp key={s.num} delay={i * 0.08}>
                            <div
                                className="border-b md:border-b-0 md:border-r border-white/10 last:border-r-0 p-8 md:p-10 h-full flex flex-col justify-between min-h-[340px] hover:bg-white/[0.02] transition-colors duration-500 group"
                                data-testid={`process-step-${s.num}`}
                            >
                                <div>
                                    <div className="flex items-center justify-between mb-8">
                                        <span className="font-display text-6xl text-white/10 group-hover:text-[#00FF66]/30 transition-colors duration-500">
                                            {s.num}
                                        </span>
                                        <span className="font-mono-tech text-xs text-white/40 uppercase tracking-widest">
                                            {s.time}
                                        </span>
                                    </div>
                                    <h3 className="font-display uppercase text-2xl text-white mb-4 tracking-tight">
                                        {s.title}
                                    </h3>
                                    <p className="text-white/60 leading-relaxed">
                                        {s.desc}
                                    </p>
                                </div>
                            </div>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
